import { c as _c } from "react/compiler-runtime";
import { Heading, TextPassage } from '@petsmart-ui/sparky';
import type { FulfillmentMethod } from '../lib';
import './set-up-autoship.scss';
const DETAILS_TEXT: Record<FulfillmentMethod, string> = {
  bopis: 'Get your item for the first time by picking it up in store today or add it to the next Autoship order being shipped to you.',
  sdd: 'Get your item for the first time by having it delivered today or add it to the next Autoship order being shipped to you.',
  sth: 'Get your item for the first time by having it delivered in 1-3 days or add it to the next Autoship order being shipped to you.'
};
type SetUpAutoshipDetailsProps = Readonly<{
  fulfillmentMethod: FulfillmentMethod;
}>;
export const SetUpAutoshipDetails = t0 => {
  const $ = _c(6);
  const {
    fulfillmentMethod
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Heading tagName="h3" size="body-bold">Choose when you want your item</Heading>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = DETAILS_TEXT[fulfillmentMethod];
  let t3;
  if ($[1] !== t2) {
    t3 = <TextPassage>{t2}</TextPassage>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TextPassage>All future orders will be shipped to you.</TextPassage>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className="set-up-autoship__details">{t1}{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};